module.exports = require('./_hide');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_redefine.js
// module id = 203
// module chunks = 17